// removed by extract-text-webpack-plugin
module.exports = {"root":"components-ChordPlayer-__index__root__1Us5l"};


//////////////////
// WEBPACK FOOTER
// ./components/ChordPlayer/index.css
// module id = 796
// module chunks = 0